<template>
  <component :is="element" class="pdl-media-object" :class="classes">
    <div class="pdl-media-object__media">
      <!-- @slot Slot for images and other media formats. -->
      <slot name="media">media</slot>
    </div>
    <div class="pdl-media-object__content">
      <!-- @slot Slot for primarily text content. -->
      <slot name="content">content</slot>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    /**
     * HTML element rendered for the wrapping container.
     */
    element: {
      type: String,
      default: 'div',
    },
    /**
     * Reverses the position of the media slot.
     */
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'pdl-media-object--reversed': this.reversed,
      };
    },
  },
};
</script>

<style lang="scss">
@import 'MediaObject.scss';
</style>
